import {Axios} from '../axios/axios'
//价格表单
export const getPricingMatrixData = (e) => {
  return Axios({
    url:"/adminapi/getPricingMatrix",
    method:'POST',
    data:e
  })
}
//批量保存价格 ADMINAPI/batchSaveZonePrices
export const batchSaveZonePrices = (e) => {
  return Axios({
    url:"/adminapi/batchSaveZonePrices",
    method:'POST',
    data:e
  })
}
//tier 列表 adminapi/getTierPricing
export const getTierPricing = (e) => {
  return Axios({
    url:"/adminapi/getTierPricing",
    method:'POST',
    data:e
  })
}
//尺寸列表 adminapi/getSizeCoefficients

export const getSizeCoefficients = (e) => {
  return Axios({
    url:"/adminapi/getSizeCoefficients",
    method:'POST',
    data:e
  })
}
//尺寸编辑 adminapi/saveSizeCoefficient
export const saveSizeCoefficient = (e) => {
  return Axios({
    url:"/adminapi/saveSizeCoefficient",
    method:'POST',
    data:e
  })
}
//创建/保存tier adminapi/saveTierPricing
export const saveTierPricing = (e) => {
  return Axios({
    url:"/adminapi/saveTierPricing",
    method:'POST',
    data:e
  })
}
//删除tier 标签 adminapi/deleteTierPricing
export const deleteTierPricing = (e) => {
  return Axios({
    url:"/adminapi/deleteTierPricing",
    method:'POST',
    data:e
  })
}
//tier 下拉 adminapi/getTierDropdownList
export const getTierDropdownlist = (e) => {
  return Axios({
    url:"/adminapi/getTierDropdownList",
    method:'POST',
    data:e
  })
}
